import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, updateData} from '../../../services/management/accommodation/accommodationServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Swal from 'sweetalert2';
import Spinner from '../../../components/Spinner';


const PendingAccommodation = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ 
    id: '',
    pr_id : '',
    accommodation_status : '',
    first_name : '',
    last_name : '',
    occupancy: '',
    no_of_nights : '',
    accompany_name : '',
    check_in: '',
    check_out: '',
    remarks: '',
    hotel_name: '',
    conf_shortname: '',
    sub_domain: '',
    series: '',
    venue: '',
    confirmation_no: '',
    verified: ''
    });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  
  
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ verified: 0 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData]);

  const handleSubmit = async () => {
    try {
      if (modalType === 'edit') {
        const updatedForm = { ...form, verified: 1 }; // Set status to 1
        await updateData(updatedForm);
      }
      fetchData();
      setShowModal(false);
    // ✅ Show success alert with auto-close
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: `Pending Accommodation ${modalType === 'add' ? 'added' : 'Approved'} successfully!`,
            timer: 2000, // 2 seconds
            showConfirmButton: false,
          });
    
        } catch (error) {
          console.error('Error during form submission:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Something went wrong while submitting the form!',
          });
        }
  };

  const openModal = (type, data = { id: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

 

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList.filter((data) => 
    data.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
    data.last_name.toLowerCase().includes(searchText.toLowerCase()) ||
    data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
    data.hotel_name.toLowerCase().includes(searchText.toLowerCase()) ||
    data.venue.toLowerCase().includes(searchText.toLowerCase()) ||
    data.conf_shortname.toLowerCase().includes(searchText.toLowerCase()) ||
    data.accompany_name.toLowerCase().includes(searchText.toLowerCase())
  )
  .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
    },
    {
        name: 'SubDomain',
        selector: (row) => row.sub_domain,
        sortable: true,
    },
    {
    name: 'Series',
    selector: (row) => {
        // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
        const date = new Date(row.series);
        
        // Format as "2025-11 Nov 2025"
        const year = date.getFullYear();
        const month = date.getMonth(); // 0-based index, so we add 1
        const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
    
        return ` ${months[month]} ${year}`;
    },
    sortable: true,
    },
    {
        name: 'First Name',
        selector: (row) => row.first_name,
        sortable: true,
    },
    {
        name: 'Last Name',
        selector: (row) => row.last_name,
        sortable: true,
    },      
    {
        name: 'Shortname',
        selector: (row) => row.conf_shortname,
        sortable: true,
    },
       
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)}>Edit</Button>
        </div>
      ),
    },
  ];
  
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4">Conference Management / Accommodation / Pending Accommodation</p>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText} onChange={handleSearchChange} />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add ' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Table striped bordered hover responsive className="table-sm">
                <thead>
                     
                    </thead>
                    <tbody>
                    </tbody>
                    <br></br>
                    <thead>
                      <tr>
                        <th className='bg-secondary text-white' colSpan={2}>Accommodation Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>First Name</td>
                        <td>{form.first_name	}</td>
                      </tr>
                      <tr>
                        <td>Last Name</td>
                        <td>{form.last_name}</td>
                      </tr>
                      <tr>
                        <td>Occupancy</td>
                        <td>{form.occupancy}</td>
                      </tr>
                      <tr>
                        <td>No of Nights</td>
                        <td>{form.no_of_nights}</td>
                      </tr>
                      <tr>
                        <td>Accommodation Status</td>
                        <td>{form.accommodation_status}</td>
                      </tr>                     
                      <tr>
                        <td>Accompany Name</td>
                        <td>{form.accompany_name}</td>
                      </tr>
                      <tr>
                        <td>Check In</td>
                        <td>{form.check_in}</td>
                      </tr>
                      <tr>
                        <td>Check out</td>
                        <td>{form.check_out}</td>
                      </tr>
                      <tr>
                        <td>Remarks</td>
                        <td>{form.remarks}</td>
                      </tr>
                      <tr>
                        <td>Hotel Name</td>
                        <td>{form.hotel_name}</td>
                      </tr>
                      <tr>
                        <td>Shortname</td>
                        <td>{form.conf_shortname}</td>
                      </tr>
                      <tr>
                        <td>SubDomain</td>
                        <td>{form.sub_domain}</td>
                      </tr>
                      <tr>
                        <td>Series</td>
                        <td>{form.series}</td>
                      </tr>            
                    </tbody>
                    <br></br>
                  </Table>
             
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleSubmit}>{modalType === 'add' ? 'Add' : 'Approved'}</Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default PendingAccommodation;
